





































import { Component, Prop, Vue } from "vue-property-decorator";
import { AllowedPostSettings } from "@/services/channels/types";
import order from "@/components/posts/PostTypeOrder";

@Component({})
export default class CreatePostContextMenu extends Vue {
        @Prop() private allowedPostTypes!: AllowedPostSettings[];
        @Prop() private channelId!: string;

        get postTypes() {
            return this.allowedPostTypes.sort((a, b) => order.indexOf(a.postType) - order.indexOf(b.postType));
        }

        // methods
        openItemsModal() {
            this.$emit("openItemsModal", {
                channelId: this.channelId,
                selectedItemTypes: this.allowedPostTypes.map(x => x.postType)
            });
        }

        navigateToItem(type: string) {
            if (type.toLowerCase() === "fixedhtml") {
                this.$emit("openHtmlItemModal", this.channelId, type);
                return;
            }
            if (type.toLocaleLowerCase() === "html") {
                this.$emit("openCustomItemModal", this.channelId, type);
                return;
            }

            this.$router.push({
                name: "createPost",
                params: {
                    channelId: this.channelId,
                    postType: type
                }
            });
        }
}
